export const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
  >
    <g clipPath="url(#clip0_1862_473)">
      <path
        d="M8.80714 0.330475C8.36071 -0.108978 7.63571 -0.108978 7.18929 0.330475L2.61786 4.83048C2.17143 5.26993 2.17143 5.9836 2.61786 6.42305C3.06429 6.86251 3.78929 6.86251 4.23571 6.42305L6.85714 3.84258V11.25C6.85714 11.8723 7.36786 12.375 8 12.375C8.63214 12.375 9.14286 11.8723 9.14286 11.25V3.84258L11.7643 6.42305C12.2107 6.86251 12.9357 6.86251 13.3821 6.42305C13.8286 5.9836 13.8286 5.26993 13.3821 4.83048L8.81071 0.330475H8.80714ZM2.28571 12.375C2.28571 11.7527 1.775 11.25 1.14286 11.25C0.510714 11.25 0 11.7527 0 12.375V14.625C0 16.4883 1.53571 18 3.42857 18H12.5714C14.4643 18 16 16.4883 16 14.625V12.375C16 11.7527 15.4893 11.25 14.8571 11.25C14.225 11.25 13.7143 11.7527 13.7143 12.375V14.625C13.7143 15.2473 13.2036 15.75 12.5714 15.75H3.42857C2.79643 15.75 2.28571 15.2473 2.28571 14.625V12.375Z"
        fill="#B3B3B3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1862_473">
        <rect width="16" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
